/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';

const __vue_script__ = {
    name: 'AttendanceTrackingSettings',

    components: { BaseInput, BaseSelect, Checkbox },

    props: {
        attendanceTracking: {
            type: Object,
            required: true
        },
        event: {
            type: Object,
            require: false,
            default: null
        },
        eventId: {
            type: String,
            required: false,
            default: null
        }
    },

    data() {
        const eventFormat = this.event?.traits?.event_format ?? 'hybrid';

        return {
            inPersonEventActivated: {},
            virtualEventActivated: {},
            eventActivatedOptionsInPerson: [
                { value: 'app_activated', label: this.$t('general_settings.form.event_activated_options_in_person.app_activated') },
                { value: 'sessions_count', label: this.$t('general_settings.form.event_activated_options_in_person.sessions_count') }
            ],
            eventActivatedOptionsVirtual: [
                { value: 'app_activated', label: this.$t('general_settings.form.event_activated_options_virtual.app_activated') },
                { value: 'sessions_count', label: this.$t('general_settings.form.event_activated_options_virtual.sessions_count') }
            ],
            attendedSessionInPerson: {},
            attendedInPersonSessionOptions: [],
            possibleAttendedInPersonSessionOptions: [
                { value: 'scanned', label: this.$t('general_settings.form.scanned') },
                { value: 'participated_activity', label: this.$t('general_settings.form.participated_activity') }
            ],
            attendedSessionVirtual: {},
            attendedVirtualSessionOptions: [
                { value: 'total', label: this.$t('general_settings.form.watch_time.total') },
                { value: 'percentage', label: this.$t('general_settings.form.watch_time.percentage') }
            ],
            attendedBreakoutsVirtual: {},
            attendedBreakoutsOptions: [
                { value: 'total', label: this.$t('general_settings.form.watch_time.total') },
                { value: 'percentage', label: this.$t('general_settings.form.watch_time.percentage') }
            ],
            showAttendedSessionInPerson: false,
            showMinSessionsToAttend: false,
            showMinSessionsToAttendVitual: false,
            hasSessionCheckInInstalled: false,
            hasLiveStreamsInstalled: false,
            showInPersonFields: eventFormat === 'in_person' || eventFormat === 'hybrid',
            showVirtualFields: eventFormat === 'virtual' || eventFormat === 'hybrid',
            temp: {},
        };
    },

    watch: {
        inPersonEventActivated() {
            const inPersonEventActivated = this.inPersonEventActivated?.value === 'app_activated';
            this.$set(this.attendanceTracking, 'in_person_event_activated', inPersonEventActivated);
            this.showMinSessionsToAttend = !inPersonEventActivated;
            const key = 'in_person_event_attended_min_sessions';
            if (inPersonEventActivated) {
                // Reset the other value
                this.addToTemp(key);
                this.$set(this.attendanceTracking, key, null);
            } else {
                // Use temp value
                this.$set(this.attendanceTracking, key, this.temp[key]);
            }
        },
        virtualEventActivated() {
            const virtualEventActivated = this.virtualEventActivated?.value === 'app_activated';
            this.$set(this.attendanceTracking, 'virtual_event_activated', virtualEventActivated);
            this.showMinSessionsToAttendVitual = !virtualEventActivated;
            const key = 'virtual_event_attended_min_sessions';
            if (virtualEventActivated) {
                // Reset the other value
                this.addToTemp(key);
                this.$set(this.attendanceTracking, key, null);
            } else {
                // Use temp value
                this.$set(this.attendanceTracking, key, this.temp[key]);
            }
        },
        attendedSessionInPerson() {
            const useParticipatedActivity = this.attendedSessionInPerson?.value === 'participated_activity';
            this.$set(this.attendanceTracking, 'in_person_session_participated_activity', useParticipatedActivity);
            this.$set(this.attendanceTracking, 'in_person_session_scanned_for_attendance', !useParticipatedActivity);
        },
        attendedSessionVirtual() {
            const usePercentage = this.attendedSessionVirtual?.value === 'percentage';
            const current = usePercentage ? 'virtual_session_watchtime_in_percent' : 'virtual_session_watchtime_in_minutes';
            const other = usePercentage ? 'virtual_session_watchtime_in_minutes' : 'virtual_session_watchtime_in_percent';
            this.addToTemp(other);
            // Reset the other value
            this.$set(this.attendanceTracking, other, null);
            // Use temp value
            this.$set(this.attendanceTracking, current, this.temp[current]);
        }
    },

    async mounted() {
        this.temp = { ...this.attendanceTracking };
        this.inPersonEventActivated = this.attendanceTracking.in_person_event_activated ? this.eventActivatedOptionsInPerson[0] : this.eventActivatedOptionsInPerson[1];
        this.virtualEventActivated = this.attendanceTracking.virtual_event_activated ? this.eventActivatedOptionsVirtual[0] : this.eventActivatedOptionsVirtual[1];
        this.showMinSessionsToAttend = !this.attendanceTracking.in_person_event_activated;
        this.showMinSessionsToAttendVitual = !this.attendanceTracking.virtual_event_activated;

        this.setAttendedSessionInPerson();
        this.setAttendedSessionVirtual();
        this.attendedBreakoutsVirtual = this.attendedBreakoutsOptions[0]; // we only count total watch time for breakouts

        // Uncomment this when we need to add the "Participated in interactivity (polling/Q&A)" option
        // if (this.eventId) {
        //     await this.fetchInstalledPackages();
        //     this.handleSessionCheckInInstalled();
        //     this.handleLiveStreamsInstalled();

        //     if (!this.hasSessionCheckInInstalled && !this.hasLiveStreamsInstalled) {
        //         this.$set(this.attendanceTracking, 'in_person_session_participated_activity', false);
        //         this.$set(this.attendanceTracking, 'in_person_session_scanned_for_attendance', false);
        //     }
        // } else {
        //     this.attendedInPersonSessionOptions = this.possibleAttendedInPersonSessionOptions;
        //     this.attendedSessionInPerson = this.attendanceTracking.in_person_session_participated_activity ?
        //         this.possibleAttendedInPersonSessionOptions[1] :
        //         this.possibleAttendedInPersonSessionOptions[0];
        //     this.showAttendedSessionInPerson = true;
        // }

        // Remove this when we need to add the "Participated in interactivity (polling/Q&A)" option
        this.showAttendedSessionInPerson = true;
        this.attendedInPersonSessionOptions.push(this.possibleAttendedInPersonSessionOptions[0]);
        this.attendedSessionInPerson = this.possibleAttendedInPersonSessionOptions[0];
    },

    methods: {
        async fetchInstalledPackages() {
            const packages = await this.$services.market.getInstalledPackages(this.eventId);
            const packageNames = Object.keys(packages);
            this.hasSessionCheckInInstalled = packageNames.includes('session-check-in') || packageNames.includes('sessions-attendance');
            this.hasLiveStreamsInstalled = packageNames.includes('live-streams');
        },

        handleSessionCheckInInstalled() {
            if (this.hasSessionCheckInInstalled) {
                this.attendedInPersonSessionOptions.push(this.possibleAttendedInPersonSessionOptions[0]);

                if (this.attendanceTracking.in_person_session_scanned_for_attendance || !this.hasLiveStreamsInstalled) {
                    this.attendedSessionInPerson = this.possibleAttendedInPersonSessionOptions[0];
                    this.showAttendedSessionInPerson = true;
                }
            }
        },

        handleLiveStreamsInstalled() {
            if (this.hasLiveStreamsInstalled) {
                this.attendedInPersonSessionOptions.push(this.possibleAttendedInPersonSessionOptions[1]);

                if (this.attendanceTracking.in_person_session_participated_activity || !this.hasSessionCheckInInstalled) {
                    this.attendedSessionInPerson = this.possibleAttendedInPersonSessionOptions[1];
                    this.showAttendedSessionInPerson = true;
                }
            }
        },

        setAttendedSessionInPerson() {
            if (this.attendedInPersonSessionOptions.length > 1) {
                this.showAttendedSessionInPerson = true;
            }
            if (this.attendanceTracking.in_person_session_participated_activity) {
                this.attendedSessionInPerson = this.attendedInPersonSessionOptions[1];
            } else {
                this.attendedSessionInPerson = this.attendedInPersonSessionOptions[0];
            }
        },

        setAttendedSessionVirtual() {
            this.attendedSessionVirtual = this.attendanceTracking.virtual_session_watchtime_in_minutes ?
                this.attendedVirtualSessionOptions[0] :
                this.attendedVirtualSessionOptions[1];
        },

        /** @param {string} key */
        addToTemp(key) {
            this.temp[key] = this.attendanceTracking[key];
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attendance-tracking-settings"},[(_vm.showInPersonFields)?_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.in_person_attendees')))]),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"in_person_event_activated"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{attrs:{"name":"in_person_event_activated","track-by":"value","error":errors,"label":_vm.$t('general_settings.form.attended_event'),"options":_vm.eventActivatedOptionsInPerson,"tip":_vm.$t('general_settings.messages.in_person_attendance')},model:{value:(_vm.inPersonEventActivated),callback:function ($$v) {_vm.inPersonEventActivated=$$v},expression:"inPersonEventActivated"}})]}}],null,false,3655146546)}),(_vm.showMinSessionsToAttend)?_c('div',{staticClass:"feature-dependant"},[_c('validation-provider',{attrs:{"rules":"min_value:1|max_value:1000","slim":true,"name":"min_sessions_to_attend_in_person"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.$t('general_settings.form.min_sessions_to_attend'),"disabled":false,"name":"min_sessions_to_attend_in_person","type":"number","errors":errors},model:{value:(_vm.attendanceTracking.in_person_event_attended_min_sessions),callback:function ($$v) {_vm.$set(_vm.attendanceTracking, "in_person_event_attended_min_sessions", $$v)},expression:"attendanceTracking.in_person_event_attended_min_sessions"}})]}}],null,false,3234429753)})],1):_vm._e(),(_vm.showAttendedSessionInPerson)?_c('validation-provider',{attrs:{"slim":true,"name":"attended_session_in_person"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{attrs:{"name":"attended_session_in_person","disabled":_vm.attendedInPersonSessionOptions.length < 2,"track-by":"value","errors":errors,"label":_vm.$t('general_settings.form.attended_session'),"options":_vm.attendedInPersonSessionOptions},model:{value:(_vm.attendedSessionInPerson),callback:function ($$v) {_vm.attendedSessionInPerson=$$v},expression:"attendedSessionInPerson"}})]}}],null,false,851599793)}):_vm._e()],1):_vm._e(),(_vm.showVirtualFields)?_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.virtual_attendees')))]),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"virtual_event_activated"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{attrs:{"name":"virtual_event_activated","track-by":"value","errors":errors,"label":_vm.$t('general_settings.form.attended_event'),"options":_vm.eventActivatedOptionsVirtual},model:{value:(_vm.virtualEventActivated),callback:function ($$v) {_vm.virtualEventActivated=$$v},expression:"virtualEventActivated"}})]}}],null,false,1144741254)}),(_vm.showMinSessionsToAttendVitual)?_c('div',{staticClass:"feature-dependant"},[_c('validation-provider',{attrs:{"rules":"min_value:1|max_value:1000","slim":true,"name":"min_sessions_to_attend_virtual"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.$t('general_settings.form.min_sessions_to_attend'),"disabled":false,"name":"min_sessions_to_attend_virtual","type":"number","errors":errors},model:{value:(_vm.attendanceTracking.virtual_event_attended_min_sessions),callback:function ($$v) {_vm.$set(_vm.attendanceTracking, "virtual_event_attended_min_sessions", $$v)},expression:"attendanceTracking.virtual_event_attended_min_sessions"}})]}}],null,false,3886901561)})],1):_vm._e(),_c('label',[_vm._v(_vm._s(_vm.$t('general_settings.form.attended_session')))]),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"attended_live_session"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{attrs:{"name":"attended_live_session","track-by":"value","errors":errors,"label":_vm.$t('general_settings.form.attended_live_session_title'),"options":_vm.attendedVirtualSessionOptions},model:{value:(_vm.attendedSessionVirtual),callback:function ($$v) {_vm.attendedSessionVirtual=$$v},expression:"attendedSessionVirtual"}})]}}],null,false,2782602069)}),_c('div',{staticClass:"feature-dependant"},[_c('validation-provider',{attrs:{"rules":"min_value:1|max_value:1000","slim":true,"name":"min_watch_time"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [(_vm.attendedSessionVirtual.value === 'total')?_c('base-input',{attrs:{"label":_vm.$t('general_settings.form.watch_time.min_watch_time'),"name":"min_watch_time","errors":errors,"type":"number"},model:{value:(_vm.attendanceTracking.virtual_session_watchtime_in_minutes),callback:function ($$v) {_vm.$set(_vm.attendanceTracking, "virtual_session_watchtime_in_minutes", $$v)},expression:"attendanceTracking.virtual_session_watchtime_in_minutes"}}):_vm._e()]}}],null,false,3391569048)}),(_vm.attendedSessionVirtual.value === 'percentage')?_c('validation-provider',{attrs:{"rules":"min_value:1|max_value:100","slim":true,"name":"Watch time %"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.$t('general_settings.form.watch_time.watch_time_percentage'),"disabled":false,"name":"Watch time %","errors":errors,"type":"number","min":1,"max":100},model:{value:(_vm.attendanceTracking.virtual_session_watchtime_in_percent),callback:function ($$v) {_vm.$set(_vm.attendanceTracking, "virtual_session_watchtime_in_percent", $$v)},expression:"attendanceTracking.virtual_session_watchtime_in_percent"}})]}}],null,false,4095210195)}):_vm._e()],1),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"attended_video_breakouts"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{attrs:{"name":"attended_video_breakouts","disabled":"disabled","track-by":"value","errors":errors,"label":_vm.$t('general_settings.form.attended_video_breakouts_title'),"options":_vm.attendedBreakoutsOptions},model:{value:(_vm.attendedBreakoutsVirtual),callback:function ($$v) {_vm.attendedBreakoutsVirtual=$$v},expression:"attendedBreakoutsVirtual"}})]}}],null,false,603188290)}),_c('div',{staticClass:"feature-dependant"},[_c('validation-provider',{attrs:{"rules":"min_value:1|max_value:1000","slim":true,"name":"min_watch_time_breakouts"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [(_vm.attendedBreakoutsVirtual.value === 'total')?_c('base-input',{attrs:{"label":_vm.$t('general_settings.form.watch_time.min_watch_time'),"name":"min_watch_time_breakouts","errors":errors,"type":"number"},model:{value:(_vm.attendanceTracking.breakout_watchtime_in_minutes),callback:function ($$v) {_vm.$set(_vm.attendanceTracking, "breakout_watchtime_in_minutes", $$v)},expression:"attendanceTracking.breakout_watchtime_in_minutes"}}):_vm._e()]}}],null,false,1859422824)})],1)],1):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AttendanceTrackingSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__